import Tabs from "@/components/Tabs";
import { Path } from "@/router";
import { useParams } from "react-router-dom";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const { pgaId } = useParams();

  if (!pgaId) return null;

  return (
    <>
      <Tabs
        showWhenSingle
        tabItems={[{ label: "Beneficiaries", link: `/people/${pgaId}/benefits/beneficiaries` as Path }]}
      />
      <div className="flex flex-col" data-testid="tab-content">
        {children}
      </div>
    </>
  );
}
